import React, { useEffect } from 'react';

function ModalVisorPdf({
    isOpen,
    onClose,
    pdfBase64,
    title = 'Reporte de Saldos y Movimientos'
}) {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };

        if (isOpen) {
            document.body.style.overflow = 'hidden';
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const dataUri = pdfBase64 
        ? (pdfBase64.startsWith('data:application/pdf;base64,') ? pdfBase64 : `data:application/pdf;base64,${pdfBase64}`)
        : null;

    return (
        <div 
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.55)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
                padding: '1rem'
            }}
            onClick={onClose}
        >
            <div 
                style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    width: '100%',
                    maxWidth: '880px',
                    height: '86vh',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.25)',
                    animation: 'fadeInModal 0.2s ease-out'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <style>{`
                    @keyframes fadeInModal {
                        from { opacity: 0; transform: scale(0.97); }
                        to { opacity: 1; transform: scale(1); }
                    }
                `}</style>

                {/* Cabecera del Modal */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '16px 24px',
                    borderBottom: '1px solid #e2e8f0',
                    backgroundColor: '#ffffff'
                }}>
                    <h5 style={{
                        margin: 0,
                        color: '#202A52',
                        fontSize: '18px',
                        fontWeight: 700
                    }}>
                        {title}
                    </h5>
                    <button 
                        type="button"
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#202A52',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px'
                        }}
                        title="Cerrar visor"
                    >
                        <i className="material-icons" style={{ fontSize: '24px', color: '#202A52' }}>close</i>
                    </button>
                </div>

                {/* Cuerpo del Visor de PDF */}
                <div style={{
                    flex: 1,
                    backgroundColor: '#f8fafc',
                    padding: '12px',
                    overflow: 'hidden',
                    position: 'relative'
                }}>
                    {dataUri ? (
                        <embed 
                            src={`${dataUri}#toolbar=1&navpanes=0`} 
                            type="application/pdf" 
                            width="100%" 
                            height="100%" 
                            style={{
                                border: 'none',
                                borderRadius: '8px',
                                width: '100%',
                                height: '100%'
                            }} 
                        />
                    ) : (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            color: '#64748b'
                        }}>
                            No se pudo cargar el documento PDF.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ModalVisorPdf;
